<script setup lang="ts">
import type { IProps } from './TeamMember.types'

const { showLearnMoreButton = false } = defineProps<IProps>()

defineEmits(['showMore'])

const { t } = useI18n()
</script>

<template>
  <div class="Team-Member">
    <img
      v-if="boardMemberPhoto"
      class="Team-Member__photo"
      :src="boardMemberPhoto"
    >

    <p class="Team-Member__name">
      {{ boardMemberName }}
    </p>

    <p class="Team-Member__role">
      {{ boardMemberRole }}
    </p>

    <button
      v-if="showLearnMoreButton"
      :aria-label="learnMoreAriaLabel ?? t('common.more')"
      class="Team-Member__more"
      @click="$emit('showMore')"
    >
      <span>{{ $t('common.more') }}</span>

      <img
        src="/icons/step/arrow_right.svg"
        class="Team-Member__moreIcon"
        alt="Previous"
      >
    </button>
  </div>
</template>

<style scoped lang="scss">
.Team-Member {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 15.6rem;

  &__photo {
    width: 10.8rem;
    height: 12rem;
    margin-bottom: 1.6rem;
    border-radius: 1.6rem;
    object-fit: cover;
  }

  &__name {
    @include body-1-medium;
    margin-bottom: 0.8rem;
    color: $text-400;
    text-align: center;
  }

  &__role {
    @include body-2-medium;
    min-height: 4rem;
    margin-bottom: 0;
    color: $text-300;
    text-align: center;
  }

  &__more {
    @include body-2-medium;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    padding-bottom: 0.2rem;
    color: $text-400;
    border-bottom: 1px solid $purple-500;
    cursor: pointer;

    &Icon {
      font-size: 1.2rem;
    }
  }
}

@include atM {
  .Team-Member {
    width: 28rem;

    &__photo {
      width: 18rem;
      height: 20rem;
      margin-bottom: 2.4rem;
    }

    &__name {
      @include h9;
    }

    &__role {
      @include body-2-medium;
      margin-bottom: 2.4rem;
    }
  }
}
</style>
